import * as http from '@xhs/http'

const BUILD_ENV = process.env.BUILD_ENV
const NODE_ENV = process.env.NODE_ENV

function getBridgeAdapter() {
  return require('./xhrByBridgeAdapter').default // eslint-disable-line global-require
}

function getMidwayAdapter() {
  return require('./httpByMidwayAdapter').default // eslint-disable-line global-require
}

const Http = {
  name: 'httpPlugin',
  installed: false,
  install(app, Launcher, options) {
    if (Http.installed) {
      return
    }

    let defaultConfig = {
      timeout: 10000,
      uploadTimeout: 60000,
      adapter: getBridgeAdapter(),
    }

    if (!process.env.BROWSER) {
      defaultConfig = Object.assign(defaultConfig, {
        adapter: getMidwayAdapter(),
        context: app.context,
      })
    }

    let baseURL = ''

    if (options.BASE_URL) {
      // Webpack must define the env variables
      const buildEnvBaseURL = options.BASE_URL[BUILD_ENV]
      const nodeEnvBaseURL = options.BASE_URL[NODE_ENV]

      baseURL = buildEnvBaseURL !== undefined ? buildEnvBaseURL : nodeEnvBaseURL

      if (baseURL === undefined) {
        throw new Error(`[Launcher Exception] could not found BASE_URL via NODE_ENV ${NODE_ENV}`)
      }
    }

    if (options.BASE_CONFIG) {
      const userDefaultConfig = options.BASE_CONFIG.defaults
      const buildEnvBaseConfig = options.BASE_CONFIG[BUILD_ENV]
      const nodeEnvBaseConfig = options.BASE_CONFIG[NODE_ENV]
      const userEnvConfig = buildEnvBaseConfig !== undefined
        ? buildEnvBaseConfig
        : nodeEnvBaseConfig

      if (typeof userDefaultConfig === 'object') {
        Object.assign(defaultConfig, userDefaultConfig)
      }

      if (typeof userEnvConfig === 'object') {
        Object.assign(defaultConfig, userEnvConfig)
      }
    }

    if (!process.env.BROWSER) {
      const http = require('http') // eslint-disable-line
      const https = require('https') // eslint-disable-line

      defaultConfig.httpAgent = new http.Agent({ keepAlive: true })
      defaultConfig.httpsAgent = new https.Agent({ keepAlive: true })
    }

    http.configure({
      baseURL,
      apiList: options.API_LIST,
      defaults: defaultConfig,
    })

    Http.installed = true
  },
  /* eslint-disable */
  create(app, Launcher, ops) {
    const ClientRequestHeaders = app.context?.request?.headers || {}
    const HeaderKeys = ['cookie', 'authorization', 'user-agent', 'xy-common-params', 'xy-platform-info']
    let DefaultHeaders = { ...Http.axios.defaults.headers }

    HeaderKeys.map(key => {
      delete DefaultHeaders[key]
      if (Reflect.has(ClientRequestHeaders, key)) {
        DefaultHeaders[key] = ClientRequestHeaders[key]
      }
    })

    Http.axios.defaults.headers = DefaultHeaders
  },
  ...http,
}

export default Http